import { GlassCard } from "@/components/glass-card"
import { UserPlus, Heart, Gift, ArrowRight } from "lucide-react"

interface Step {
  stepNumber: number
  title: string
  description: string
  icon: string
}

interface ProcessSectionProps {
  title: string
  steps: Step[]
}

const iconMap = {
  "user-plus": UserPlus,
  heart: Heart,
  gift: Gift,
}

export function ProcessSection({ title, steps }: ProcessSectionProps) {
  return (
    <section className="py-12 md:py-24">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-12">{title}</h2>

        <div className="max-w-4xl mx-auto">
          <div className="grid gap-6 md:grid-cols-3">
            {steps.map((step, index) => {
              const IconComponent = iconMap[step.icon as keyof typeof iconMap]
              const isLast = index === steps.length - 1

              return (
                <div key={step.stepNumber} className="flex items-center">
                  <GlassCard className="flex-1 text-center p-6">
                      <div className="w-16 h-16 mx-auto bg-primary/10 rounded-full flex items-center justify-center mb-4">
                        <IconComponent className="w-8 h-8 text-primary" />
                      </div>
                      <h3 className="font-semibold mb-2">{step.title}</h3>
                      <p className="text-sm text-muted-foreground">{step.description}</p>
                  </GlassCard>

                  {!isLast && (
                    <div className="hidden md:flex items-center justify-center w-12">
                      <ArrowRight className="w-6 h-6 text-muted-foreground" />
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
